// branded colors are prefixed with the brand name; common colors are not
export const breadWarningBase = "#FFDA58";
export const breadPositiveBase = "#008849";
export const breadNegativeBase = "#E42A16";
export const breadNeutralBase = "#ABABAB";
export const breadFocusBlue = "#275DC5";
export const breadDarkOcean = "#13294B";
export const breadSeaFoam = "#59BEC9";
export const breadCerulean = "#007DBA";
export const breadWine = "#7A4282";
export const breadQuince = "#E03C31";
export const breadMustard = "#FFB81C";

// This color is under Transactions > Light Charged Back BG here: https://www.figma.com/file/c6E30VgFUIYIl3pBjJ6KVa/Merchant-Components?node-id=1901-12&t=zq44daQJyHhOh5Z9-0
export const breadSlightlyDarkerSeaFoam = "#00A9BB";
// This color is 4% of bread primary. Taken from button figma here: https://www.figma.com/file/72B9FiXmWonl70WTwJPfXt/Dough-2.0-Design-System?node-id=1080-55916&t=7w0N2B3zkPSmK1ku-0
export const breadPrimary04 = "rgba(28, 129, 149, 0.04)";
// This color is 16% of bread primary. Taken from button figma here: https://www.figma.com/file/72B9FiXmWonl70WTwJPfXt/Dough-2.0-Design-System?node-id=1080-55916&t=7w0N2B3zkPSmK1ku-0
export const breadPrimary16 = "rgba(28, 129, 149, 0.16)";

export const breadPrimary = "#1C8195";
// This color was determined by Vanessa the designer @vdemartino during button redesign
// It is about 75% opacity of breadPrimary
export const breadPrimaryLight = "#55A1B0";
// This color was determined by Vanessa the designer @vdemartino during button redesign
// It is 50% opacity of breadPrimary
export const breadPrimaryMediumLight = "#7caeb8";
// This color was determined by Vanessa the designer @vdemartino during button redesign
// It is 30% opacity of breadPrimary
export const breadPrimaryEvenMoreMediumLight = "#BAD9DF";
// This color was generated via https://mui.com/material-ui/customization/color/ with breadPrimary as primary
export const breadPrimaryDark = "#135a68";
// This color was determined by Vanessa the designer @vdemartino
// This color is about 5% opacity of breadPrimary
export const breadPrimaryVeryLight = "#F3F8F9";

export const breadSecondary = breadDarkOcean;
// This color was generated via https://mui.com/material-ui/customization/color/ with breadSecondary as secondary
export const breadSecondaryDark = "#0d1c34";
// This color was generated via https://mui.com/material-ui/customization/color/ with breadSecondary as secondary
export const breadSecondaryLight = "#42536f";

export const breadError = breadNegativeBase;
// This color was generated via https://mui.com/material-ui/customization/color/ with breadNegativeBase as primary
export const breadErrorLight = "#e95444";
// This color was generated via https://mui.com/material-ui/customization/color/ with breadNegativeBase as primary
export const breadErrorDark = "#9f1d0f";

export const breadWarning = breadWarningBase;
// This color was generated via https://mui.com/material-ui/customization/color/ with breadWarningBase as primary
export const breadWarningLight = "#ffe179";
// This color was used in the Account Settings Figma for Placement Settings https://www.figma.com/file/KKV8vHePic8eSCB5GNABUn/Account-Settings?type=design&node-id=12550-126298&t=P7jbJXc2dNp6AdXQ-0
export const breadWarningVeryLight = "#fffbee";
// This color was generated via https://mui.com/material-ui/customization/color/ with breadWarningBase as primary
export const breadWarningDark = "#b2983d";

export const breadInfo = breadCerulean;
// This color was generated via https://mui.com/material-ui/customization/color/ with breadCerulean as primary
export const breadInfoLight = "#3397c7";
// This color was generated via https://mui.com/material-ui/customization/color/ with breadCerulean as primary
export const breadInfoDark = "#005782";

export const breadSuccess = breadPositiveBase;
// This color was generated via https://mui.com/material-ui/customization/color/ with breadPositiveBase as primary
export const breadSuccessLight = "#339f6d";
// This color was generated via https://mui.com/material-ui/customization/color/ with breadPositiveBase as primary
export const breadSuccessDark = "#005f33";
// This color was taken from the logo in the top left of the Merchant Portal. The origin of this color is unknown.
export const breadTopLeftLogoText = "#00205C";

export const breadBlack = "#333333";
export const breadOverlay = "#919192";
export const breadGray = "#4E5C6F";
export const breadLightGray = "#8a93a0";
export const breadLineGray = "#c7cbd1";
export const breadOffWhite = "#FAFAFA";
export const breadWhite = "#FFFFFF";

export const rbcBrightBlue = "#0051A5";
export const rbcBrightBlueTint1 = "#006AC3";
export const rbcBrightBlueTint2 = "#73B0E3";
export const rbcBrightBlueTint4 = "#E3F4FF";
export const rbcYellow = "#FEDF01";
export const rbcWarmRed = "#F93F26";
export const rbcRed = "#9B301B";
export const rbcDeepGold = "#E8CF00";
export const rbcMossGreen = "#B5A80C";
export const rbcAppleGreen = "#AABA0A";
export const rbcSky = "#51B5E0";
export const rbcGreen = "#6B702B";
export const rbcSlate = "#6F6E6F";
export const rbcLightGray = "#C1B5A5";

export const rbcPrimary = rbcBrightBlueTint1;
export const rbcPrimaryLight = rbcBrightBlueTint2;
export const rbcPrimaryDark = rbcBrightBlue;
export const rbcPrimaryVeryLight = rbcBrightBlueTint4;

export const rbcSecondary = rbcYellow;
// This color was generated via https://mui.com/material-ui/customization/color/ with rbcYellow as primary
export const rbcSecondaryLight = "#FFEF91";
export const rbcSecondaryVeryLight = "#f8f0bf";
export const rbcSecondaryDark = rbcMossGreen;

export const rbcError = rbcWarmRed;
// This color was picked from https://m2.material.io/inline-tools/color/ rbcWarmRed, 300
export const rbcErrorLight = "#EB706B";
export const rbcErrorDark = rbcRed;

export const rbcWarning = rbcDeepGold;
// This color is the 700 value of rbcDeepGold
export const rbcWarningLight = "#EFDB65";
export const rbcWarningDark = rbcMossGreen;

// This color is the 700 value of rbcSky in the PDF document
export const rbcInfo = "#78CCF3";
// This color is the 400 value of rbcSky in the PDF document
export const rbcInfoLight = "#B3E0F8";
export const rbcInfoDark = rbcSky;

// This color is the 900 value of rbcGreen in the PDF document
export const rbcSuccess = "#738136";
// This color is the 700 value of rbcGreen in the PDF document
export const rbcSuccessLight = "#8D975B";
export const rbcSuccessDark = rbcGreen;
// This color was taken from the logo in the top left of the Merchant Portal. The origin of this color is unknown.
export const rbcTopLeftLogoText = "#102233";

// This color is the 100 value of Light Gray in the PDF document
export const rbcVeryLightGrey = "#F7F6F4";
// These values came from our old theme, and we do not know their origin
export const rbcDarkGray = "#0F2233";

// common colors (ie colors that are the same across both tenants) can be imported straight from this file
export const white = "#FFFFFF";
export const white50 = "rgba(255, 255, 255, 0.5)";
export const white70 = "rgba(255, 255, 255, 0.7)";
export const black = "#000000";
export const shadowColor = "rgba(0, 0, 0, 0.18)";

// RBC brand colors: https://usermanual.wiki/Document/DesignerGuidetoColourValues.331608072.pdf
// Bread brand colors: https://www.figma.com/file/72B9FiXmWonl70WTwJPfXt/Dough-2.0-Design-System?node-id=34-1440&t=nx7AVjUhcMtRXh9Z-0
// Bread & RBC Theme Figma: https://www.figma.com/file/c6E30VgFUIYIl3pBjJ6KVa/Merchant-Components?node-id=1215-0&t=zq44daQJyHhOh5Z9-0
